import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_OTHER_EQUIPMENT',
  GET: 'GET_OTHER_EQUIPMENT',
  CREATE: 'CREATE_OTHER_EQUIPMENT',
  EDIT: 'EDIT_OTHER_EQUIPMENT',
  DELETE: 'DELETE_OTHER_EQUIPMENT',
  DUPLICATE: 'DUPLICATE_OTHER_EQUIPMENT',
  CLEAR_ERROR: 'CLEAR_ERROR_OTHER_EQUIPMENT',
};

export const clearErrorOtherEquipment = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchOtherEquipmentByText = (text, page = 0, excludeZoneId = null) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchOtherEquipment(pageSize, page, sorted, filtered, isPublic, excludeZoneId);
};

const searchOtherEquipment = (pageSize, page, sorted, filtered, isPublic, excludeZoneId = null) => {
  const zoneParams = excludeZoneId && { not__zone_id: excludeZoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_OTHER_EQUIPMENT,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const listOtherEquipment = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchOtherEquipment(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const createOtherEquipment = (name, power_required, description, image, cfpValue, cfpUnit) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('power_required', power_required);
  if (typeof description === 'string') formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `equipment_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_OTHER_EQUIPMENT,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editOtherEquipment = (id, name, powerRequired, description, image, cfpValue, cfpUnit) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (powerRequired) formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `equipment_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_OTHER_EQUIPMENT}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteOtherEquipment = equipmentId => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_OTHER_EQUIPMENT}${equipmentId}/`,
    })
      .then(() => ({ id: equipmentId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateOtherEquipment = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_OTHER_EQUIPMENT}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/other_equipment/equipment_actions.js